import Components from "../../components";
import { useNavigate } from "react-router-dom";

const Orders = ({ data, dataSetter }) => {
  const navigate = useNavigate();
  const onBackClick = () => {
    navigate("/account");
  };
  return (
    <div>
      <Components.PageHeader
        id="page-header"
        label="Page Header"
        title="Siparişlerim"
        onBackClick={onBackClick}
        safeArea={data?.system?.safeArea}
        pixelRatio={data?.system?.pixelRatio}
      />
      <Components.Orders
        id="orders"
        label="Orders"
        data={data}
        dataSetter={dataSetter}
      />
    </div>
  );
};

export default Orders;
